import React from 'react'

function SuccessModalContent({ title, description = null, onNext }) {
  return (
    <>
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content new-brp-modal">
          <div className="modal-body dome-d-flex dome-gap12 dome-flex-column dome-align-center">
            <i className="fa-thin fa-circle-check dome-color-go-green" style={{ fontSize: '46px', margin: 'auto' }}></i>
            <p className="dome-h2 dome-text-w300 dome-color-dark-grey">{title}</p>
            <p className="dome-p2">{description}</p>
          </div>
          <div className="modal-footer dome-d-flex">
            <button
              type="submit"
              className="dome-btn dome-btn-base dome-btn-green-stroke"
              style={{ margin: 'auto' }}
              onClick={onNext}
            >
              ok
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default SuccessModalContent
